import React from 'react'
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom'
import { Button,Card } from 'react-bootstrap';
import bg_img  from "../../images/Home/bg.png"

const Home = () => {
  const navigate = useNavigate();    

  var formats = [
      <Button style={{padding:"0",margin:"10px 0"}} onClick={()=>{
        // localStorage.setItem("type","general")
        // navigate('/create');
        }}>
          <Card style={{ width: '18rem' ,color:"black"}}>
            <Card.Body>
              <Card.Title>General</Card.Title>
              <Card.Text>
                Create an instant General survey
              </Card.Text>
            </Card.Body>
          </Card>
        </Button>,
      <Button style={{padding:"0",margin:"10px 0"}} onClick={()=>{
        // localStorage.setItem("type","hotel")
        // navigate('/create');
      }}>
          <Card style={{ width: '18rem' ,color:"black"}}>
            <Card.Body>
              <Card.Title>Hotel</Card.Title>
              <Card.Text>
                Create an instant survey about Hotels
              </Card.Text>
            </Card.Body>
          </Card>
      </Button>,
      <Button style={{padding:"0",margin:"10px 0"}} onClick={()=>{
        // localStorage.setItem("type","customer")
        // navigate('/create');
        }}>
          <Card style={{ width: '18rem' ,color:"black"}}>
            <Card.Body>
              <Card.Title>Customer</Card.Title>
              <Card.Text>
                Create an Customer Satisfaction Survey
              </Card.Text>
            </Card.Body>
          </Card>
        </Button>,
    ]

  var window_height = window.innerHeight
  
  return (
    <div style={{ background:"linear-gradient(135deg, #fdfcfb 10%, #e2d1c3 100%)"}}>
      <div className="container" style={{height:window_height,}}>
        <div className="display-1 pt-5" style={{fontWeight:"600"}} >Formify</div>

        <p style={{"padding":"5%","fontSize":"20px"}}>Formify is an online survey tool which allows users to create and distribute customer surveys through multiple channels, as well as evaluate responses. </p>

        {/* <div style={{"paddingTop":"3%","display":"flex",justifyContent:"space-around",alignItems:"center",flexWrap:"wrap"}}>
          {formats.map((f)=>{
          return  f;
        })}
        </div> */}

      </div>
    </div>
  )
}

export default Home
